module.exports = __webpack_public_path__ + "static/img/labour-1.e8bdcfb.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/rescuelist/img/list/labour-1.png
// module id = /ftp
// module chunks = 1